/**
 * Game + class-aware pill color choosers, shared across inventory views.
 */

export const GAMES = ["Pokemon", "Pokemon (Japan)", "Magic: The Gathering", "Yu-Gi-Oh", "One Piece", "Riftbound", "Lorcana", "Flesh & Blood", "Dragon Ball Fusion World", "Other"];

export function gamePill(g: string | undefined | null): string {
  switch (g) {
    case "Pokemon": return "amber";
    case "Pokemon (Japan)": return "rose";
    case "Magic: The Gathering": return "blue";
    case "Yu-Gi-Oh": return "emerald";
    case "One Piece": return "red";
    case "Riftbound": return "cyan";
    case "Lorcana": return "violet";
    default: return "gray";
  }
}

export function classPill(c: string | undefined | null): string {
  const v = (c || "").toLowerCase();
  if (v.includes("hold")) return "violet";
  if (v.includes("rip")) return "amber";
  if (v.includes("dealer")) return "blue";
  return "gray";
}
